"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var BillingApiOperationFindQueryDto_1;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiOperationFindQueryDto = void 0;
const billing_core_operation_type_enum_1 = require("../../../../billing-core/billing-core-account/types/enums/billing-core-operation-type.enum");
const key_value_1 = require("../../../../shared/types/key-value");
const swagger_1 = require("../../../../swagger-fake");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
let BillingApiOperationFindQueryDto = BillingApiOperationFindQueryDto_1 = class BillingApiOperationFindQueryDto {
  /** Из похожего объекта или объекта того же типа */
  static fromLike(obj) {
    if (obj instanceof BillingApiOperationFindQueryDto_1) {
      return (0, class_transformer_1.instanceToInstance)(obj);
    }
    const filter = new BillingApiOperationFindQueryDto_1();
    filter.type = obj.type;
    return filter;
  }
};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Операции по типу",
  enum: billing_core_operation_type_enum_1.BillingCoreOperationTypeEnum,
  required: false,
  isArray: true,
  nullable: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsEnum)(billing_core_operation_type_enum_1.BillingCoreOperationTypeEnum, {
  each: true
}), __metadata("design:type", Object)], BillingApiOperationFindQueryDto.prototype, "type", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Поиск операций связанных с конкретным(и) charge",
  required: false,
  type: 'string',
  isArray: true,
  nullable: true,
  items: {
    format: 'uuid'
  }
}), __metadata("design:type", Object)], BillingApiOperationFindQueryDto.prototype, "chargeId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Поиск операций связанных с конкретным(и) order",
  required: false,
  type: 'string',
  isArray: true,
  nullable: true,
  items: {
    format: 'uuid'
  }
}), __metadata("design:type", Object)], BillingApiOperationFindQueryDto.prototype, "orderId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Поиск операций связанных с начислениями найденными по указанным meta",
  required: false,
  type: String,
  format: "json",
  example: "{\"meetingId\":\"202675c9-0700-4472-bb2e-a2d2c2b2c401\"}"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Type)(() => key_value_1.Metadata), __metadata("design:type", Object)], BillingApiOperationFindQueryDto.prototype, "chargeMeta", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Поиск операций связанных со сделками найденными по указанным meta",
  required: false,
  type: String,
  format: "json",
  example: "{\"meetingId\":\"202675c9-0700-4472-bb2e-a2d2c2b2c401\"}"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Type)(() => key_value_1.Metadata), __metadata("design:type", Object)], BillingApiOperationFindQueryDto.prototype, "orderMeta", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Поиск операций связанных с конкретным(и) contractor",
  required: false,
  type: 'string',
  isArray: true,
  nullable: true,
  items: {
    format: 'uuid'
  }
}), __metadata("design:type", Object)], BillingApiOperationFindQueryDto.prototype, "contractorId", void 0);
BillingApiOperationFindQueryDto = BillingApiOperationFindQueryDto_1 = __decorate([(0, class_transformer_1.Exclude)()], BillingApiOperationFindQueryDto);
exports.BillingApiOperationFindQueryDto = BillingApiOperationFindQueryDto;
